import { FormattedMessage, useIntl } from 'react-intl'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import BodyText from 'LuxKit/Typography/BodyText'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LoyaltyInclusions from 'loyalty/components/LoyaltyInclusions'

interface Props {
  inclusions: Array<App.PackageInclusion>
  loyaltyInclusions?: Array<App.OfferInclusion>
}

export function HotelSummaryInclusions({ inclusions, loyaltyInclusions }: Props) {
  const intl = useIntl()
  const bonusInclusions = inclusions.filter(inclusion => inclusion.isBonus)
  const regularInclusions = inclusions.filter(inclusion => !inclusion.isBonus)
  const hasBonusInclusions = bonusInclusions.length > 0

  return (
    <VerticalSpacer gap={12}>
      {regularInclusions && regularInclusions.length > 0 && (
        <div>
          <BodyText variant="medium" weight="bold">
            <FormattedMessage
              id="7TkY0OrBDIS8K1W86dK-"
              defaultMessage="Package inclusions:"
              description="Label for the list of items included in the hotel package"
            />
          </BodyText>
          {regularInclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} isHighlighted={inclusion.isHighlighted} />)}
          {!hasBonusInclusions && <LoyaltyInclusions inclusions={loyaltyInclusions} variant="offer-page" />}
        </div>
      )}
      {hasBonusInclusions && (
        <div>
          <BodyText variant="medium" weight="bold" format="propercase">{intl.formatMessage({
            id: 'QHEyfbSSWAYmH81kVqvg',
            defaultMessage: 'Extra inclusions:',
            description: 'Label for bonus inclusions list in hotel summary inclusions section',
          })}
          </BodyText>
          {bonusInclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} />)}
          <LoyaltyInclusions inclusions={loyaltyInclusions} variant="offer-page" />
        </div>
      )}
    </VerticalSpacer>
  )
}
